import { combineReducers } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'
import { connectRouter } from 'connected-react-router'

import { session } from './sessionReducer'
import { convSums } from './convSumsReducer'
import { modals } from './modalsReducer'
import { notifications } from './notificationsReducer'
import isLoading from './isLoadingReducer'
import { DestroySession } from '../constants/actionTypes'
import adminUsers from './adminUsers'
import loans from './loans'
import makes from './makes'
import offers from './offers'
import productPackages from './productPackages'
import refiTransactions from './refiTransactions'
import refis from './refis'
import stipulationMappings from './stipulationMappings'
import tasks from './tasks'
import users from './users'
import vehicles from './vehicles'
import { allMakesModels } from './vehicles'
import vehicleOptions from './vehicleOptions'
import businessConfig from './businessConfigReducer'
import { configurationReducer } from './configurationReducer'
import { organizationReducer } from './organizationReducer'
import refiApplication from './refiApplication'

const appReducer = (history) =>
  combineReducers({
    adminUsers,
    allMakesModels,
    convSums,
    form: reduxFormReducer,
    isLoading,
    loans,
    makes,
    modals,
    notifications,
    offers,
    productPackages,
    refiTransactions,
    refis,
    router: connectRouter(history),
    session,
    stipulationMappings,
    tasks,
    users,
    vehicles,
    vehicleOptions,
    businessConfig,
    configurations: configurationReducer,
    organizations: organizationReducer,
    refiApplication,
  })

const createRootReducer = (history) => (state, action) => {
  if (action.type === DestroySession) {
    state = undefined
  }

  return appReducer(history)(state, action)
}

export default createRootReducer

export * from './adminUsers'
export * from './loans'
export * from './makes'
export * from './offers'
export * from './productPackages'
export * from './refiTransactions'
export * from './refis'
export * from './sessionReducer'
export * from './stipulationMappings'
export * from './tasks'
export * from './users'
export * from './vehicles'
export * from './businessConfigReducer'
